// Haptic feedback helpers for mobile UX.
// Uses navigator.vibrate (Android) + iOS ignores gracefully.
// Call these on user-initiated actions only.

const canVibrate = () => typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

export const hapticTap = () => {
  if (canVibrate()) navigator.vibrate(10);
};

export const hapticMedium = () => {
  if (canVibrate()) navigator.vibrate(20);
};

export const hapticSuccess = () => {
  if (canVibrate()) navigator.vibrate([15, 40, 30]);
};

export const hapticError = () => {
  if (canVibrate()) navigator.vibrate([50, 80, 50]);
};

export const hapticWarning = () => {
  if (canVibrate()) navigator.vibrate([25, 60]);
};
